import request from "./request";
/**
 * 批量删除发帖历史记录
 * @param data 记录id数组
 */
export default async function deleteSendHistory(data) {
  return await request.post("/spin/dataSend/deleteSendHistory", data);
}
